import React from "react";
import "./Styles.scss";
import { Switch, Route, withRouter } from "react-router-dom";
import withMotion from "../../Utils/withMotion";

//Panels
import PageNotFound from "../../404";
import Hero from "./Hero/Hero";
import Variations from "./Pages/Variations/Variations";
import Styles from "./Pages/Styles/Styles";
import { SpeakWithDesigner } from "../../CTA/CTA";

const Services = () => {
  return (
    <div className="container-fluid page-styles">
      <Hero />
      <Switch>
        <Route component={Variations} path={`/styles/variations`} />
        <Route component={Styles} path={`/styles/style`} />
        <Route exact component={PageNotFound} path="*" />
      </Switch>
      <SpeakWithDesigner />
    </div>
  );
};

export default withRouter(withMotion(Services));
